import type { ReactNode } from "react"
import { ChevronDown } from "lucide-react"
import { cn } from "@/lib/utils"

export interface OptimizerToolbarProps {
  titleLabel?: string
  focusLabel: string
  infoSlot?: ReactNode
  showConfig: boolean
  onToggle: () => void
  showConfigLabel?: string
  hideConfigLabel?: string
  className?: string
}

export function OptimizerToolbar({
  titleLabel = "Optimizer For",
  focusLabel,
  infoSlot,
  showConfig,
  onToggle,
  showConfigLabel = "Show Configurations",
  hideConfigLabel = "Hide Configurations",
  className,
}: OptimizerToolbarProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={cn(
        "flex items-center justify-between w-full cursor-pointer group",
        className,
      )}
    >
      <div className="flex items-center gap-2">
        <h2 className="text-section text-foreground">
          {titleLabel}: <span className="text-primary">{focusLabel}</span>
        </h2>
        {infoSlot}
      </div>
      <div className="flex items-center gap-1.5 text-caption text-muted-foreground group-hover:text-foreground transition-colors">
        {showConfig ? hideConfigLabel : showConfigLabel}
        <ChevronDown
          size={12}
          strokeWidth={1.5}
          className={cn(
            "transition-transform duration-150",
            showConfig && "rotate-180",
          )}
        />
      </div>
    </button>
  )
}
